<template>
  <div>
    <div class="form">
      <tooltip v-show="filedErrors.hasOwnProperty('time_cost')" class="form__validation">
        {{ $t('errors.field_required') }}
      </tooltip>
      <div class="label">{{ $t('ticket_types.time_cost') }} *</div>
      <textarea
        name="timeCost"
        placeholder="1h/1€
2h/2€
24h/6€"
        @focusout="setTicketData('time_cost', $event.target.value)"
      >{{ subData ? subData.rules_string : '' }}</textarea>
      <div class="explanation">{{ $t('ticket_types.explanation') }}</div>
    </div>
  </div>

</template>

<script>

import '../../styles.scss'
import {storeMixin} from '../../mixins/storeMixin.js'
import {mapGetters} from "vuex";
import Tooltip from "../../../../common/Tooltip";

export default {
  mixins: [storeMixin],
  props: ['subData'],
  components: {
    Tooltip
  },
  computed: {
    ...mapGetters({
      filedErrors: 'tenants/ticketTypes/filedErrors',
    })
  },
}

</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/ExtraFields/fixed.vue